import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PUBLIC_SERVICE_CATALOG_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetServiceCatalogResult } from '../types/getServiceCatalog.types';

export const PUBLIC_SERVICE_CATALOG_TAG = 'getPublicServiceCatalog';

export const getPublicServiceCatalog = (builder: BuilderType) =>
  builder.query<GetServiceCatalogResult[], void>({
    providesTags: [PUBLIC_SERVICE_CATALOG_TAG],
    query: () => ({
      data: {},
      method: 'POST',
      url: GET_PUBLIC_SERVICE_CATALOG_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetServiceCatalogResult[]>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
